import qs from 'qs';
import { API, RPC } from '../../../constants';
import request from '../../../lib/request';

const getAll = (page, { areaManager, state, active, collaboratore }, orderField, orderDirection) =>
  request({
    url: API.RECESSO,
    method: 'GET',
    params: {
      page,
      filter: [
        areaManager && {
          type: 'eq',
          field: 'responsabileArea',
          value: areaManager,
        },
        state && {
          type: 'eq',
          field: 'state',
          value: state,
        },
        collaboratore && {
          type: 'innerjoin',
          field: 'collaboratore',
          alias: 'collaboratoreAlias',
        },
        collaboratore && {
          type: 'innerjoin',
          parentAlias: 'collaboratoreAlias',
          alias: 'anagraficaAlias',
          field: 'anagrafica',
        },
        collaboratore && {
          alias: 'anagraficaAlias',
          type: 'like',
          field: 'nominativo',
          value: `%${collaboratore}%`,
        },
        active === true && {
          type: 'in',
          field: 'state',
          values: [0, 1, 2, 3],
        },
      ].filter(Boolean),
      'order-by': [
        {
          type: 'field',
          field: orderField || 'updatedAt',
          direction: orderDirection !== 'none' ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getTotalRecessi = () =>
  request({
    url: RPC.GESTIONE_RECESSO,
    method: 'POST',
    data: {
      method: 'get_total_recessi',
    },
  });

const getRecesso = (id) =>
  request({
    url: `${API.RECESSO}/${id}`,
    method: 'GET',
  });

const createRecesso = (data) =>
  request({
    url: API.RECESSO,
    method: 'POST',
    data,
  });

const updateRecesso = (id, data) =>
  request({
    url: `${API.RECESSO}/${id}`,
    method: 'PUT',
    data,
  });

const patchRecesso = (id, data) =>
  request({
    url: `${API.RECESSO}/${id}`,
    method: 'PATCH',
    data,
  });

const deleteRecesso = (id) =>
  request({
    url: `${API.RECESSO}/${id}`,
    method: 'DELETE',
  });

const postNewNote = (data) =>
  request({
    url: API.RECESSO_NOTE,
    method: 'POST',
    data,
  });

const getNotesByRecesso = (recessoId) =>
  request({
    url: API.RECESSO_NOTE,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'recesso',
          value: recessoId,
        },
      ],
      'order-by': [
        {
          type: 'field',
          field: 'updatedAt',
          direction: 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const RecessoService = {
  getAll,
  getRecesso,
  createRecesso,
  updateRecesso,
  patchRecesso,
  deleteRecesso,
  postNewNote,
  getNotesByRecesso,
  getTotalRecessi,
};

export default RecessoService;



// WEBPACK FOOTER //
// ./app/shared/services/api/recesso/index.js